<template>
  <div>
    <img src="../../assets/imgs/customer-service.png" width="100%" alt />
    <van-cell title="电话客服" is-link @click="contact">
      <b class="place-text">工作日9:00～18:00</b>
    </van-cell>
    <!-- <p class="color999 width-351" style="line-height:20px; margin-top:12px">
      
    </p>-->
  </div>
</template>

<script>
export default {
  name: "CustomerService",
  data() {
    return {};
  },
  components: {},
  methods: {
    contact() {
      const tel = "400-921-6690";
      this.$dialog
        .confirm({ message: "拨打" + tel + "，联系客服" })
        .then(() => {
          window.location.href = "tel:" + tel;
        });
    }
  }
};
</script>

<style scoped>
.place-text {
  color: #ccc;
}
.van-cell__right-icon {
  color: #ccc;
}
</style>
